import { isApiError } from '@/lib/api/error'
import { ForbiddenPage } from './forbidden-page'
import { NotFoundPage } from './not-found-page'
import { ServerErrorPage } from './server-error-page'

export function GlobalErrorFallback({ error, reset }: { error: unknown; reset?: () => void }) {
  if (isApiError(error)) {
    if (error.status === 403) return <ForbiddenPage />
    if (error.status === 404) return <NotFoundPage />
  }
  return <ServerErrorPage onRetry={reset} />
}
